var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrokenHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4C20.72 4 19.4666 4.33333 18.36 4.92L16 12H20L16 25.3333L17.3333 13.3333H13.3333L15.3866 6.14667C13.96 4.81333 12.0133 4 9.99996 4C5.89329 4 2.66663 7.22667 2.66663 11.3333C2.66663 16.84 8.21329 20.9067 16 28C23.2933 21.4133 29.3333 16.9867 29.3333 11.3333C29.3333 7.22667 26.1066 4 22 4Z",
    fill: "url(#paint0_linear_217_2133)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_2133",
    x1: 29.3333,
    y1: 16,
    x2: 2.66663,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5576C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F093FB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenHeartIcon);
export default __webpack_public_path__ + "static/media/BrokenHeartIcon.8de104be1092f8e36fef3af23a389905.svg";
export { ForwardRef as ReactComponent };